import request from "./client";

export function getProperty(id) {
  return request({
    method: 'GET',
    url: '/api/v1/properties/' + id,
    responseType: 'json'
  });
}

export function updateProperty(id, data) {
  return request({
    method: "PUT",
    url: "/api/v1/properties/" + id,
    data: data,
    responseType: "json"
  });
}

export function createProperty(id, data) {
  return request({
    method: 'POST',
    url: '/api/v1/properties/' + id,
    data: data,
    responseType: 'json'
  });
}

export function deleteProperty(id, data) {
  return request({
    method: "DELETE",
    url: "/api/v1/properties/" + id,
    data: data,
    responseType: "json"
  });
}

export function getPropertiesByUserId() {
  return request({
    method: "POST",
    url: "/api/v1/getPropertiesByUserId",
    data: {},
    responseType: "json"
  });
}

export function listPaginatedHotelsUsingQuery(options) {
  // let page = options.page || 1;
  // let limit = options.limit || 10;
  // let userId = options.userId;

  const data = {};
  data.page = options.page || 1;
  data.limit = options.limit || 10;
  data.userId = options.userId;

  return request({
    // method: 'GET',
    // url: '/api/v1/employee-groups/' + '?page=' + page + '&limit=' + limit
    // + (search !== "" ? '&search=' + search : ""),
    // responseType: 'json'

    method: "POST",
    url: "/api/v1/listPaginatedHotelsUsingQuery",
    data: data,
    responseType: "json"
  });
}



// WEBPACK FOOTER //
// ./src/gateways/properties.js